export { default } from "./NotFoundSection.js";
